import { WizardStepStatus } from '../../WizardStep/types';
import { WizardStepsState } from '../../WizardStep/useWizardSteps/types';

export const selectSignatoriesStepName = 'select-signatories-step';
export const signatoryContactInformationStepName = 'signatory-contact-information-step';
export const signDocumentStepName = 'sign-document-step';

export const initialWizardState: WizardStepsState = {
  steps: {
    [selectSignatoriesStepName]: {
      isOpen: true,
      status: WizardStepStatus.Active,
      stepNumber: 1,
    },
    [signatoryContactInformationStepName]: {
      isOpen: false,
      status: WizardStepStatus.Inactive,
      stepNumber: 2,
    },
    [signDocumentStepName]: {
      isOpen: false,
      status: WizardStepStatus.Inactive,
      stepNumber: 3,
    },
  },
};

export const initialWizardIsSigningState: WizardStepsState = {
  steps: {
    [signatoryContactInformationStepName]: {
      isOpen: true,
      status: WizardStepStatus.Active,
      stepNumber: 1,
    },
    [signDocumentStepName]: {
      isOpen: false,
      status: WizardStepStatus.Inactive,
      stepNumber: 2,
    },
  },
};
